
import { CreateUpdateUserComponent } from '../components/create-update-user/create-update-user.component';

export class DeactivateUserManagementGuard  {
  canDeactivate(component: CreateUpdateUserComponent) {
    return component.canDeactivate();
  }
}
